import type React from 'react';

const Avatar: React.FC<{ avatarImg?: string }> = ({ avatarImg }) => {
  return (
    <figure className='avatar-container'>
      {avatarImg ? (
        <img alt='' src={avatarImg} />
      ) : (
        <i className='far fa-user-circle' />
      )}
    </figure>
  );
};

export default Avatar;
